import type { MouseEvent } from 'react';
import { cn } from '@shared/utils';

interface IconProps {
  icon: React.ReactNode;
  className?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'secondary-inverse' | 'white' | 'light' | 'black' | 'red' | 'dark';
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const Icon = (props: IconProps) => {
  return (
    <div
      className={cn(
        !props.color && 'text-slate dark:text-white',
        props.color === 'inherit' && 'text-inherit',
        props.color === 'primary' && 'text-primary',
        props.color === 'secondary' && 'text-primary dark:text-soft-black',
        props.color === 'secondary-inverse' && 'text-soft-black dark:text-primary',
        props.color === 'white' && 'text-white',
        props.color === 'light' && 'text-light',
        props.color === 'black' && 'text-soft-black',
        props.color === 'red' && 'text-red',
        props.color === 'dark' && 'text-slate dark:text-white/70',
        props.className,
      )}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      {props.icon}
    </div>
  );
};
